import { setTemplateUrl } from '@js-dot/api/http';

/**
 * 달콤한 모듈 주소 연결 설정
 * `loadChildren`을 대상으로 축약
 * @param path
 * @param childrenCallback
 * @param option
 */
function loadChildren(path, childrenCallback, option = {}) {
  return {
    path,
    loadChildren: childrenCallback,
    ...option
  };
}
/**
 * 달콤한 컴포넌트 주소-설정
 * `loadComponent`를 대상으로 축약
 * @param path
 * @param componentCallback
 * @param option
 */
function loadComponent(path, componentCallback, option = {}) {
  return {
    path,
    loadComponent: componentCallback,
    ...option
  };
}
/**
 * 달콤한 인덱스 주소-설정
 * 빈 경로를 주소 연결 경로로 `redirectTo` 를 대상으로 축약
 * @param route
 */
function indexRoute(route) {
  return [redirectTo(route.path), route];
}
/**
 * 달콤한 재연결 주소-설정
 * `redirectTo`를 대상으로 축약
 * @param slug
 */
function redirectTo(slug) {
  return {
    path: '',
    pathMatch: 'full',
    redirectTo: slug
  };
}
const shellRoute = (childrenCallback, option = {}) => loadChildren('', childrenCallback, option);
/**
 * @param loadMethod
 */
function routeFactory(loadMethod) {
  function getPageRoute(defineId, slugs, menu, route, option) {
    if (!Array.isArray(slugs)) {
      slugs = [slugs];
    }
    const slug = slugs[slugs.length - 1];
    const path = '/' + slugs.join('/');
    const routePage = {
      slug,
      path,
      route: importCallback => loadMethod(slug, importCallback, route)
    };
    routePage.menu = {
      defined: defineId,
      path,
      ...(menu || {})
    };
    if (path.includes(':')) {
      const entries = Object.entries((option || {}).routeMap || {});
      routePage.link = model => {
        let current = entries.length;
        while (current-- > 0) {
          const [to, from] = entries[current];
          model[to] = model[from];
        }
        const result = setTemplateUrl(path, model);
        return result;
      };
    } else {
      routePage.link = () => path;
    }
    return routePage;
  }
  return getPageRoute;
}
/**
 * 지연 컴포넌트 용 주소-설정 및 메뉴 인자 선언 함수
 * @function
 * @param defineId 정의 아이디
 * @param slugs 경로
 * @param menu 메뉴 설정
 * @param route 라우터 설정
 */
const routineForComponent = routeFactory(loadComponent);
/**
 * 지연 자식-주소-연결 용 주소-설정 및 메뉴 인자 선언 함수
 * @function
 * @param defineId 정의 아이디
 * @param slugs 경로
 * @param menu 메뉴 설정
 * @param route 라우터 설정
 */
const routineForChildren = routeFactory(loadChildren);
function menuReplaceFactory(size) {
  const after = 'menu' + size + ':';
  return function menuReplace(...menus) {
    return menus.flat().map(menuReplacer);
  };
  function menuReplacer(menu) {
    return typeof menu?.icon === 'string' ? {
      ...menu,
      icon: menu.icon.replace('menu24:', after)
    } : menu;
  }
}
/**
 * 메뉴 아이콘의 크기를 48로 변경 합니다.
 * @example 메뉴 아이콘 변환
 * ```ts
 * @NgModule({
 * 	imports: [
 * 		MenuModule({
 * 			primary: menu48(
 * 				*_ROUTINE.menu,
 * 				*_ROUTINE.menu
 * 			)
 * 		});
 * 	]
 * })
 * class AppShellModule {
 * }
 * ```
 *
 * @param menus
 */
const menu48 = menuReplaceFactory(48);
/**
 * 메뉴 아이콘의 크기를 96로 변경 합니다.
 * @example 메뉴 아이콘 변환
 * ```ts
 * @NgModule({
 * 	imports: [
 * 		MenuModule({
 * 			primary: menu96(
 * 				*_ROUTINE.menu,
 * 				*_ROUTINE.menu
 * 			)
 * 		});
 * 	]
 * })
 * class AppShellModule {
 * }
 * ```
 *
 * @param menus
 */
const menu96 = menuReplaceFactory(96);

/**
 * Generated bundle index. Do not edit.
 */

export { indexRoute, loadChildren, loadComponent, menu48, menu96, redirectTo, routineForChildren, routineForComponent, shellRoute };
